import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../styles/Clientes.css";

import cliente1 from "../assets/clientes/baptistaleal.png";
import cliente2 from "../assets/clientes/correta.png";
import cliente3 from "../assets/clientes/fiepe.png";
import cliente4 from "../assets/clientes/manaira.png";
import cliente5 from "../assets/clientes/petrobras.gif";

const logos = [cliente1, cliente2, cliente3, cliente4, cliente5];

const Clientes = () => {
  const [index, setIndex] = useState(0);

  // Mostra 3 logos por vez
  const visibleLogos = [
    logos[index % logos.length],
    logos[(index + 1) % logos.length],
    logos[(index + 2) % logos.length],
    logos[(index + 3) % logos.length],
  ];

  // Avança automaticamente a cada 3 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % logos.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="clientes-section">
      <h2 className="clientes-titulo">Nossos Clientes</h2>
      <p className="clientes-subtitulo">Empresas que confiam em nosso trabalho</p>

      <div className="clientes-container">
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            className="clientes-faixa"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.6 }}
          >
            {visibleLogos.map((logo, i) => (
              <img
                key={i}
                src={logo}
                alt={`Cliente ${i + 1}`}
                className="clientes-logo"
              />
            ))}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Bolinhas de navegação */}
      <div className="clientes-bolinhas">
        {logos.map((_, i) => (
          <div
            key={i}
            className={`bolinha ${i === index % logos.length ? "ativa" : ""}`}
            onClick={() => setIndex(i)}
          ></div>
        ))}
      </div>
    </section>
  );
};

export default Clientes;
